import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=3ddbc6ad&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ddbc6ad')) {
      api.createRecord('3ddbc6ad', component.options)
    } else {
      api.reload('3ddbc6ad', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=3ddbc6ad&", function () {
      api.rerender('3ddbc6ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Hu7SuLd9NOnc/JS/comp/IncreaseNumber.vue"
export default component.exports